/**
 * cycle-5c+25-fix25 — XrefContext: a tiny React Context that exposes the
 * cross-reference lookup map (built once per items snapshot in RoadmapPage)
 * to any descendant component that wants to render <XrefText> or surface
 * "Related items" without prop-drilling.
 *
 * Shape (per buildXrefLookup):
 *   { byRef: {[Cn]: {type, original_id, title}}, byWorkbookId: {[wbId]: {ref, title}} }
 *
 * Empty default means components remain safe to render outside the provider
 * (they fall back to plain text for unresolved refs).
 */

import { createContext, useContext } from "react";

const XrefContext = createContext({ byRef: {}, byWorkbookId: {} });

export function XrefProvider({ value, children }) {
  return (
    <XrefContext.Provider value={value || { byRef: {}, byWorkbookId: {} }}>
      {children}
    </XrefContext.Provider>
  );
}

export function useXrefLookup() {
  return useContext(XrefContext);
}
